import { InputContainer } from "./form/form.module";


export const CancelReasonComponents = ({
    cancelreason,
  onFormChange,
  selectedValue
}:any) => {
  return (
    <>
 
          <>
            <div className=" grid md:grid-cols-1 lg:grid-cols-1 gap-1">
             
              <InputContainer
                label="Cancel Name"
                labelField="Reason"
                list={cancelreason}
                onValueChange={(event: any, newValue: any) => {
                    onFormChange({
                    value: event.target.value,
                    field: 'Code',
                  });
                }}
                optionName="Choose Reason"
                type="select"
                value={selectedValue?.Code}
                valueField="Code"
              />
           
            </div>
          </>
      
  
    </>
  );
};
